(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/statistics/assets/javascripts/horse-info.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/statistics/assets/javascripts/horse-info.js');

'use strict';

const {
  EmptyDataView
} = svs.racing.emptyDataView;
const {
  Skeleton
} = svs.components.lbUi;
const {
  getStatisticsNoDataMsg
} = svs.racing.common.strings;
const {
  getSexType,
  getCoatColor
} = svs.racing.common.strings;
const {
  gaits
} = svs.racing.common.constants;
const {
  statisticsService,
  statistics
} = svs.racing_game.components;
const renderHorseInfo = horse => React.createElement(React.Fragment, null, React.createElement("div", {
  className: "horse-info-item-header"
}, "H\xE4st"), React.createElement("div", {
  className: "horse-info-item-content-holder"
}, React.createElement("div", {
  className: "horse-info-item-content"
}, React.createElement("span", {
  className: "horse-info-item-content-description"
}, "K\xF6n:"), React.createElement("span", {
  className: "fc-racing-900"
}, getSexType(horse.sex) || '-')), React.createElement("div", {
  className: "horse-info-item-content"
}, React.createElement("span", {
  className: "horse-info-item-content-description"
}, "\xC5lder:"), React.createElement("span", {
  className: "fc-racing-900"
}, horse.age >= 0 ? "".concat(horse.age, " \xE5r") : '-')), React.createElement("div", {
  className: "horse-info-item-content"
}, React.createElement("span", {
  className: "horse-info-item-content-description"
}, "F\xE4rg:"), React.createElement("span", {
  className: "fc-racing-900"
}, getCoatColor(horse.coatColor)))));
const renderPedigreeInfo = pedigree => React.createElement(React.Fragment, null, React.createElement("div", {
  className: "horse-info-item-header"
}, "Stamtavla"), React.createElement("div", {
  className: "horse-info-item-content-holder"
}, React.createElement("div", {
  className: "horse-info-item-content"
}, React.createElement("span", {
  className: "horse-info-item-content-description"
}, "Far:"), React.createElement("span", {
  className: "fc-racing-900"
}, pedigree.father || '-')), React.createElement("div", {
  className: "horse-info-item-content"
}, React.createElement("span", {
  className: "horse-info-item-content-description"
}, "Mor:"), React.createElement("span", {
  className: "fc-racing-900"
}, pedigree.mother || '-')), React.createElement("div", {
  className: "horse-info-item-content"
}, React.createElement("span", {
  className: "horse-info-item-content-description"
}, "Morfar:"), React.createElement("span", {
  className: "fc-racing-900"
}, pedigree.grandfather || '-'))));
const renderParticipantInfo = (driver, trainer, owner, gait) => React.createElement(React.Fragment, null, React.createElement("div", {
  className: "horse-info-item-header"
}, "\xD6vrigt"), React.createElement("div", {
  className: "horse-info-item-content-holder"
}, React.createElement("div", {
  className: "horse-info-item-content"
}, React.createElement("span", {
  className: "horse-info-item-content-description"
}, gait === gaits.TROTTING ? 'Kusk' : 'Jockey', ":"), React.createElement("span", {
  className: "fc-racing-900"
}, driver.name || '-')), React.createElement("div", {
  className: "horse-info-item-content"
}, React.createElement("span", {
  className: "horse-info-item-content-description"
}, "Tr\xE4nare:"), React.createElement("span", {
  className: "fc-racing-900"
}, trainer.name || '-')), React.createElement("div", {
  className: "horse-info-item-content"
}, React.createElement("span", {
  className: "horse-info-item-content-description"
}, "\xC4gare:"), React.createElement("span", {
  className: "fc-racing-900"
}, owner.name || '-'))));
const renderContent = (participant, isLoading) => {
  const {
    horse,
    driver,
    trainer,
    owner
  } = participant || {};
  const pedigree = horse ? horse.pedigree : {};
  const gait = svs.utils.ns.isNamespace('svs.racing_game.data.race.gait') ? svs.racing_game.data.race.gait : '';
  return React.createElement("div", {
    className: "horse-info-content-holder gutter-xs-1 gutter-md-2"
  }, React.createElement("div", {
    className: "horse-info-content grid-row padding-xs-h-1 padding-md-h-2"
  }, React.createElement("div", {
    className: "horse-info-holder col-md-6 margin-xs-bottom-2 margin-md-bottom-2"
  }, isLoading ? React.createElement(Skeleton, {
    height: 5
  }) : renderHorseInfo(horse)), React.createElement("div", {
    className: "horse-info-holder col-md-6 margin-xs-bottom-2 margin-md-bottom-2",
    "data-testid": "pedigree-info"
  }, isLoading ? React.createElement(Skeleton, {
    height: 5
  }) : renderPedigreeInfo(pedigree)), React.createElement("div", {
    className: "horse-info-holder col-md-6 margin-xs-bottom-2 margin-md-bottom-2",
    "data-testid": "participant-info"
  }, isLoading ? React.createElement(Skeleton, {
    height: 5
  }) : renderParticipantInfo(driver, trainer, owner, gait))));
};
const renderNoData = () => React.createElement("div", {
  className: "statistics-no-data"
}, React.createElement(EmptyDataView, {
  label: getStatisticsNoDataMsg()
}));
const HorseInfo = _ref => {
  let {
    participantId
  } = _ref;
  const [data, error, isLoading] = statistics.useStatisticsData(participantId, statisticsService.fetchHorseInfo);
  return error ? renderNoData() : renderContent(data, isLoading);
};
svs.racing_game.components.statistics.HorseInfo = HorseInfo;

 })(window);